import { MatchProvider } from './MatchProvider';
import { MatchCell } from './cell/MatchCell';
import { CellButtonReferee } from './cell/CellButtonReferee';
import { CellButtonDetails } from './cell/CellButtonDetails';
import { useBracket } from '../brackets/BracketProvider';
import { useReferee } from 'src/contexts/RefereeContext';

export const MatchBracket = (props) => {
  const { id: tournamentId, gameId } = useBracket();
  const { isRefereeView } = useReferee();
  const { isLarge, ...match } = props;
  const { team1, team2 } = match;

  const CellButton = isRefereeView
    ? !!team1 &&
      !!team2 &&
      !match.winner && (
        <CellButtonReferee
          gameId={gameId}
          tournamentId={tournamentId}
          team1={team1}
          team2={team2}
        />
      )
    : (!!team1 || !!team2) && <CellButtonDetails />;

  return (
    <MatchProvider {...match}>
      <MatchCell isLarge={isLarge} Button={CellButton} />
    </MatchProvider>
  );
};
